import { render } from "./assetmodel.vue?vue&type=template&id=356376ef"
import script from "./assetmodel.vue?vue&type=script&lang=js"
export * from "./assetmodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__